exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".selWidth[data-v-cb86279a]{width:350px !important}.seachTiele[data-v-cb86279a]{line-height:35px}.fa[data-v-cb86279a]{color:#0a6aa1;display:block}.sheng[data-v-cb86279a]{color:red;display:block}", ""]);

// exports
